<template>
  <div class="goodLists">
    <div class="list acea-row row-between-wrapper">
      <div
        @click="goDetail(item)"
        v-for="(item, index) in goodList"
        :key="index"
        class="item acea-row row-between-wrapper"
      >
        <div class="pictrue">
          <img v-lazy="item.image" alt="img" class="image" />
          <span
            class="pictrue_log pictrue_log_class"
            v-if="item.activity && item.activity.type === '1'"
            >秒杀</span
          >
          <span
            class="pictrue_log pictrue_log_class"
            v-if="item.activity && item.activity.type === '2'"
            >砍价</span
          >
          <span
            class="pictrue_log pictrue_log_class"
            v-if="item.activity && item.activity.type === '3'"
            >拼团</span
          >
        </div>
        <div class="underline">
          <div class="text">
            <div class="line1 store_name">{{ item.store_name }}</div>
            <div class=" acea-row row-between-wrapper">
              <div class="vip-money">
                <div class="money icon-color">
                  ￥<span class="num">{{ item.price }}</span>
                </div>
                <del
                  class="vip"
                  v-if="
                    (item.vip_price && item.vip_price > 0) ||
                      (item.ot_price && item.ot_price > 0)
                  "
                >
                  ￥{{ item.vip_price || item.ot_price || 0 }}
                </del>
              </div>
              <div v-if="isRecom" class="rob">疯抢</div>
              <div
                class="iconfont icon-gouwuche acea-row row-center-wrapper"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="goodList.length == 0">
        <img src="@assets/images/noproduct.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { goShopDetail } from "@libs/order";
export default {
  name: "GoodLists",
  props: {
    goodList: {
      type: Array,
      default: () => []
    },
    isSort: {
      type: Boolean,
      default: true
    },
    isRecom: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {};
  },
  methods: {
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.goodLists {
  .list {
    width: 100%;
    padding: 0 4vw;
    .item {
      width: 44vw;
      margin-bottom: 3vw;
      .pictrue {
        width: 44vw;
        height: 44vw;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .underline {
        width: 100%;
        .text {
          .store_name {
            font-size: 3.5vw;
            line-height: 6vw;
          }
          .money {
            font-size: 4.2vw;
          }
          .vip {
            color: #999;
            font-size: 3vw;
          }
          .rob {
            color: #fff;
            font-size: 3vw;
            background-color: #0e98fd;
            padding: 0 0.5vw;
            border-radius: 1vw;
          }
        }
      }
    }
  }
}
</style>
